import { render } from "./BaseCalendar.vue?vue&type=template&id=168e2a04&scoped=true&ts=true"
import script from "./BaseCalendar.vue?vue&type=script&lang=ts"
export * from "./BaseCalendar.vue?vue&type=script&lang=ts"

import "./BaseCalendar.vue?vue&type=style&index=0&id=168e2a04&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168e2a04"]])

export default __exports__